export const INITIAL_COMMODITY = {
  commodityOwnerCd: null,
  commodityOwnerName: "",
  commodityOwnerNameFurigana: "",
  postCode: "",
  address: "",
  tel: "",
  fax: "",
  email: "",
  feeRate: 0,
  shippingFee: 0,
  // paymentFeeId: null,
  salesRecordTypeCd: null,
  commodityOwnerTotalDivisionCd: null,
  areaCd: null,
  jaCode: null,
  relatedGroupName: "",
  closingDateGroupCd: null,
  balanceAccountCd: null,
  // supplierId: null,

  //Bank
  bankAccountId: null,
  bankCd: null,
  bankBranchCd: null,
  accountTypeCd: null,
  accountNumber: null,
  accountName: "",
  // paymentFee: null,
  // isMainAccount: true,

  //invoiceRegistrationInfo
  businessRegistrationNo: null,
  invoiceRegistrationHistoryList: [],
};

export const FIELD_ORDER = Object.keys(INITIAL_COMMODITY).filter(
  (key) => key != "bankAccountId"
);
